/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_ManageInputs */

const id_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola preferensi notifikasi push Anda.`)
};

const ms_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uruskan keutamaan pemberitahuan push anda.`)
};

const da_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrér dine push-notifikationspræferencer.`)
};

const de_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie Ihre Push-Benachrichtigungseinstellungen.`)
};

const en_us2_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your push notification preferences.`)
};

const es_es2_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra tus preferencias de notificaciones push.`)
};

const es_mx2_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra tus preferencias de notificaciones push.`)
};

const fil_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamahalaan ang iyong mga kagustuhan sa push notification.`)
};

const fr_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez vos préférences de notifications push.`)
};

const it_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci le tue preferenze per le notifiche push.`)
};

const hu_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezeld a push értesítési preferenciáidat.`)
};

const nl_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer je pushmeldingvoorkeuren.`)
};

const no_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer push-varslingspreferansene dine.`)
};

const pl_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj swoimi preferencjami powiadomień push.`)
};

const pt_br2_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your push notification preferences.`)
};

const pt_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerencie as suas preferências de notificações push.`)
};

const ro_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionează preferințele tale pentru notificări push.`)
};

const fi_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallitse push-ilmoitusasetuksiasi.`)
};

const sv_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantera dina push-notisinställningar.`)
};

const vi_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý tùy chọn thông báo đẩy của bạn.`)
};

const tr_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push bildirim tercihlerinizi yönetin.`)
};

const cs_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spravujte své předvolby push oznámení.`)
};

const bg_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управлявайте предпочитанията си за push известия.`)
};

const ru_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управляйте настройками push-уведомлений.`)
};

const uk_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Керуйте налаштуваннями push-сповіщень.`)
};

const ar_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة تفضيلات الإشعارات الفورية الخاصة بك.`)
};

const hi_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी पुश सूचना प्राथमिकताएँ प्रबंधित करें।`)
};

const th_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดการการตั้งค่าการแจ้งเตือนแบบพุชของคุณ`)
};

const ja_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュ通知の設定を管理します。`)
};

const zh_cn2_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your push notification preferences.`)
};

const zh_hant1_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your push notification preferences.`)
};

const ko_notifications_push_manage = /** @type {(inputs: Notifications_Push_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시 알림 기본 설정을 관리하세요.`)
};

/**
* | output |
* | --- |
* | "Manage your push notification preferences." |
*
* @param {Notifications_Push_ManageInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_manage = /** @type {((inputs?: Notifications_Push_ManageInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_ManageInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_manage(inputs)
	if (locale === "ms") return ms_notifications_push_manage(inputs)
	if (locale === "da") return da_notifications_push_manage(inputs)
	if (locale === "de") return de_notifications_push_manage(inputs)
	if (locale === "en-US") return en_us2_notifications_push_manage(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_manage(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_manage(inputs)
	if (locale === "fil") return fil_notifications_push_manage(inputs)
	if (locale === "fr") return fr_notifications_push_manage(inputs)
	if (locale === "it") return it_notifications_push_manage(inputs)
	if (locale === "hu") return hu_notifications_push_manage(inputs)
	if (locale === "nl") return nl_notifications_push_manage(inputs)
	if (locale === "no") return no_notifications_push_manage(inputs)
	if (locale === "pl") return pl_notifications_push_manage(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_manage(inputs)
	if (locale === "pt") return pt_notifications_push_manage(inputs)
	if (locale === "ro") return ro_notifications_push_manage(inputs)
	if (locale === "fi") return fi_notifications_push_manage(inputs)
	if (locale === "sv") return sv_notifications_push_manage(inputs)
	if (locale === "vi") return vi_notifications_push_manage(inputs)
	if (locale === "tr") return tr_notifications_push_manage(inputs)
	if (locale === "cs") return cs_notifications_push_manage(inputs)
	if (locale === "bg") return bg_notifications_push_manage(inputs)
	if (locale === "ru") return ru_notifications_push_manage(inputs)
	if (locale === "uk") return uk_notifications_push_manage(inputs)
	if (locale === "ar") return ar_notifications_push_manage(inputs)
	if (locale === "hi") return hi_notifications_push_manage(inputs)
	if (locale === "th") return th_notifications_push_manage(inputs)
	if (locale === "ja") return ja_notifications_push_manage(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_manage(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_manage(inputs)
	return ko_notifications_push_manage(inputs)
});
export { notifications_push_manage as "notifications.push.manage" }